export const SubadminInitialValues = {
    full_name: "",
    email: "",
    designation: "",
  };
  